import React, { useEffect, useState, useRef, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Link, useNavigate, useLocation, redirect } from "react-router-dom";
import { Modal, ListGroup } from "react-bootstrap";
import Login from "./Login";
import Header from "./header";
import OutsideClickHandler from "react-outside-click-handler";
import { ToastContainer } from "react-toastify";
import TawkTo from "tawkto-react";
import ExportApi from "../api/ExportApi";
import debounce from "lodash.debounce";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Cookies from 'js-cookie';
import { Skeleton, Box } from "@mui/material";


export default function navbar({showSearchBar = true}) {
  //{clearAllFilters=()=>{}}
  //function navbar({ searchValue, setSearchValue }) {
 
  const navigate = useNavigate();

  const location = useLocation();

  const [closeIcon, setCloseIcon] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [show, setShow] = useState(false);
  const [DropList, setDropList] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("tokenuser"));
  const [token1, setToken1] = useState(localStorage.getItem("admin"));
  const [userId, setUserId] = useState();
  const [key, setkey] = useState(false);
  const [loaderkey, setloaderkey] = useState(false);
  const popupRef = useRef(null);
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
  const [Data, setData] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [brandCounts, setBrandCounts] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [modelCounts, setModelCounts] = useState({});
  const [seriesCounts, setSeriesCounts] = useState({});
  const [chipsetCounts, setChipsetCounts] = useState({});
  // const [selectedData, setSelectedData] = useState({});
  const [seriesn, setSeriesn] = useState([]);
  const [modeln, setModeln] = useState([]);
  const [chipsetn, setChipsetn] = useState([]);
  const [brandsn, setBrandsn] = useState([]);
  const [newdata, setNewdata] = useState();
  const [searchdata, setSearchdata] = useState(false);

  const [searchloader, setSearchloader] = useState(false);
  const [blankdata, setBlankdata] = useState();
  const [allproducts, setAllproducts] = useState();
  const [isCompactNav, setIsCompactNav] = useState(false);

  const [showMobileSearch, setShowMobileSearch] = useState(true);
  const [isLogoutHovered, setIsLogoutHovered] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [signup, setSignup] = useState(false);
  const lastScrollYRef = useRef(0);

  useEffect(() => {
    const handleResize = () => {
      setIsCompactNav(
        typeof window !== "undefined" ? window.innerWidth <= 1024 : false
      );
    };

    // set initial value
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopUp(false);   
      }
    }

    if (showPopUp) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopUp]);

  // useEffect(() => {
  //   const Getproductdata = () => {
  //     ExportApi.Alllatestproducts()
  //       .then((resp) => {
  //         const data = resp?.data?.data;
  //         setAllproducts(data)
  

  //       })
  //       .catch((err) => console.log(err));
  //   };

  //   Getproductdata();
  // }, []);

  useEffect(() => {
    const className = "search-overlay-active";
    if (typeof document === "undefined") {
      return;
    }
    if (showPopUp && searchValue) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
    return () => {
      document.body.classList.remove(className);
    };
  }, [showPopUp, searchValue]);

  useEffect(() => {
    const contactus = new URLSearchParams(location.search);
    const paramValue = contactus.get("contactus");
    if (paramValue) {
      setShowChat(true);
    }
  }, [location.search]);

  const handleBrowseClick = (event) => {
    event.preventDefault(); // Prevent the default link behavior

    localStorage.removeItem("Compare");
      localStorage.removeItem("FavouriteProducts");
    localStorage.removeItem("selectedFilterData");
    navigate("/categories/graphic-cards");
  };
  const handleBrowselogo = (event) => {
    event.preventDefault(); // Prevent the default link behavior

 
    localStorage.removeItem("selectedFilterData");
    navigate("/");
  };
  useEffect(() => {
    // setUserId(JSON.parse(localStorage.getItem("tokenuser")).id)
    window.addEventListener("Login", () => {
      // Set the user token from localStorage
      setToken(localStorage.getItem("tokenuser"));
      setToken1(localStorage.getItem("admin"));
      setUserId(JSON.parse(localStorage.getItem("tokenuser")).id);
      // Hide a component or perform other actions
      setShow(false);
    });

    // Listen for "Loginout" event
    window.addEventListener("Loginout", () => {
      // Set a state variable to control a dropdown list
      setDropList(false);
      // Clear localStorage data
      localStorage.clear();
      // Clear tokens and navigate to the root path
      setToken();
      setToken1();
      setUserId();
      navigate("/");
    });
  }, []);

  // Function to handle cancel icon click
  const handleCancelIcon = () => {
    // Clear search-related state variables
    handleSearchClear();
    setSearchValue("");
    setCloseIcon(false);
  };

  // Function to handle closing a component or dialog
  const handleClose = () => setShow(false);

  // Function to handle showing a component or dialog
  // const handleShow = () => {

  //   if (!localStorage.getItem("tokenuser") && !localStorage.getItem("admin")) {

  //     setShow(true);
  //   } else {

  //     setShow(false);
  //     setToken(localStorage.getItem("tokenuser"));
  //     setUserId(JSON.parse(localStorage.getItem("tokenuser")).id);
  //     setDropList(true);
  //   }
  // };
  const handleShow = () => {
    const tokenUser = localStorage.getItem("tokenuser");
    const adminUser = localStorage.getItem("admin");

    // Check if tokenuser exists
    if (tokenUser) {
      // Set token and user ID from tokenuser
      setToken(tokenUser);
      const userToken = JSON.parse(tokenUser);

     
      setUserId(userToken.id);
      setDropList(true); // Show dropdown list
      setShow(false); // Hide the component
    } else if (adminUser) {
      // Set token and user ID from admin
      setToken(adminUser);
      setUserId(JSON.parse(adminUser).id);
      setDropList(true); // Show dropdown list
      setShow(false); // Hide the component
    } else {
      // No user token found, show the component
      setShow(true);
    }
  };

  const handleSearch = async (value) => {
    setSearchloader(true);
    setSearchValue(value);
    setSearchloader(true);
    if (value?.length > 0) {
      setCloseIcon(true);
      setShowPopUp(true);

      try {

        setSearchdata(true);
        const resp = await ExportApi.GetAllProductSerch(value);     
        if (resp?.data?.success) {
          setData(resp?.data?.Data);
          setSearchValue(value);
          setSearchloader(false);
        }
        else {
          setData([]);
          setSearchloader(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setSearchloader(false);
        setCloseIcon(false);
        setShowPopUp(false);
      }
    } else {
      setCloseIcon(false);
      setShowPopUp(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
  
      handleSearch(searchValue);
    }, 2000);

    return () => clearTimeout(timer);
  }, [searchValue]);

  // Function to clear search-related data and reset the search input
  const handleSearchClear = (e) => {
    setSearchValue("");
    setData([]);
  };

  useEffect(() => {
    // Retrieve user data from localStorage once at the start
    const storedData = localStorage.getItem("tokenuser");
    const userData = storedData ? JSON.parse(storedData) : {};
   
    const firstname = userData?.firstname || "testing acc";
    const email = userData?.email || "test@gmail.com";

    // Tawk.to initialization
    const tawkToPropertyId = "6583dce370c9f2407f8220c3";
    const tawkToKey = "1hi5hdmtr";

    // Initialize Tawk.to instance
     var tawkToInstance = new TawkTo(tawkToPropertyId, tawkToKey);
   
    // tawkToInstance.setAttributes({
    //   name: firstname,
    //   email: email,
    // });
     
 
    
    // Tawk.to event when chat starts
    tawkToInstance.onChatStarted(() => {
      
      console.log("Chat has started");

      // Again, retrieve user data when chat starts
      const storedUserData = localStorage.getItem("tokenuser")  || localStorage.getItem("admin");


      //console.log(storedUserData,"storedUserData>>>>>");
      const userData = storedUserData ? JSON.parse(storedUserData) : {};
      console.log(userData, "userData>>>");

      const firstname = `${userData?.firstname || 'Guest'} ${userData?.lastname || 'User'}`;
      console.log(firstname, "firstname>>>!231");
      const email = userData?.email || "guest@gmail.com";
      tawkToInstance.setAttributes(
        {
          name: firstname,
          email: email,
        },
        function (error) {
          if (error) {
            console.error("Error setting visitor attributes:", error);
          } else {
            console.log("Non-Secure Mode - Visitor details set:", { name: firstname, email });
          }
        }
      );

      const chatData = {
        chatId: new Date(),
        userId: userData?.id,
      };
  //console.log(chatData,"chatData>>>");
   
    

      // Call API to create a chat record
      ExportApi.addCreateChat(chatData)
        .then((res) => {
          console.log("Chat created successfully", res);
        })
        .catch((error) => {
          console.error("Error creating chat:", error);
        });
    });
  }, []);
 

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sendbidask = queryParams.get("pagename");
   

    if (sendbidask) {
      let token = localStorage.getItem("usertoken");
      const apiUrl =
        "https://api.gpuwiz.com/product/stripeconnectaccountredirect?pagename=" +
        sendbidask;
      // const token `Bearer ${token}`,

      const requestOptions = {
        method: "GET", // Use 'GET', 'POST', 'PUT', 'DELETE', etc. based on your API endpoint
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      fetch(apiUrl, requestOptions)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
         
          window.location.replace(data?.details);

          // Handle the API response data
        })
        .catch((error) => {
          console.error("Error bidask:", error);
          // Handle errors
        });
    }
  
    // Do something with sendPage
  }, [location]);

  const calculateBrandCounts = (filteredData) => {
    const counts = {};
    filteredData?.forEach((val) => {
      counts[val.brand] = (counts[val.brand] || 0) + 1;
    });
    setBrandCounts(counts);
  };
  const calculateModelCounts = (filteredData) => {
    const counts = {};
    filteredData?.forEach((val) => {
      counts[val.model] = (counts[val.model] || 0) + 1;
    });
    setModelCounts(counts);
  };
  const calculateSeriesCounts = (filteredData) => {
    const counts = {};
    filteredData?.forEach((val) => {
      counts[val.series] = (counts[val.series] || 0) + 1;
    });
    setSeriesCounts(counts);
  };
  const calculateChipsetCounts = (filteredData) => {
    const counts = {};
    filteredData?.forEach((val) => {
      counts[val.chipset] = (counts[val.chipset] || 0) + 1;
    });
    setChipsetCounts(counts);
  };

  // Filter data based on search input
  useEffect(() => {
    const filtered = Data?.filter((val) =>
      val?.brand?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
    calculateBrandCounts(filtered);
  }, [searchValue, Data]);

  useEffect(() => {
    const filtered = Data?.filter((val) =>
      val?.model?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
    calculateModelCounts(filtered);
  }, [searchValue, Data]);

  useEffect(() => {
    const filtered = Data?.filter((val) =>
      val?.series?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
    calculateSeriesCounts(filtered);
  }, [searchValue, Data]);

  useEffect(() => {
    const filtered = Data?.filter((val) =>
      val?.chipset.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
    calculateChipsetCounts(filtered);
  }, [searchValue, Data]);

  useEffect(() => {
    const GetDataFilterList = () => {
      ExportApi.GetAllcategoryList("63ff36fb23ad0386e761641f")
        .then((resp) => {
          const data = resp?.data?.data;
       
          if (data) {
            setSeriesn(data?.series);
            setModeln(data?.model);
            setChipsetn(data?.chipset);
            setBrandsn(data?.brands);
          }
        })
        .catch((err) => console.log(err));
    };

    GetDataFilterList();
  }, []);

  const lkey = JSON.parse(localStorage.getItem("secondData"));

  useEffect(() => {
    //const loaderkey = JSON.parse(localStorage.getItem('secondData'));
    // setloaderkey(loaderkey);
    if (lkey == true) {
      setloaderkey(lkey);
      //newhandleDataClick(newdata);
    }
  }, [lkey]);

 

  const handleDataClick = (data) => {
    // clearAllFilters()
    setNewdata(data);
    // setShowPopUp(false);
    const newkey = true;
    localStorage.setItem("newkey", newkey);
    navigate(`/categories/graphic-cards`);

    // setShowPopUp(false);
   

    let index = -1;
    switch (data.type) {
      case "chipset":
        index = chipsetn.findIndex((chip) => chip === data.name);
        break;
      case "brand":
        index = brandsn.findIndex((brand) => brand === data.name);
        break;
      case "series":
        index = seriesn.findIndex((ser) => ser === data.name);
        break;
      case "model":
        index = modeln.findIndex((mod) => mod === data.name);
        break;
      default:
        break;
    }

    data.index = index;
    localStorage.setItem("selectedData", JSON.stringify(data));
    localStorage.removeItem("newkey");
    localStorage.removeItem("secondData");

    navigate(`/categories/graphic-cards`);

    //}
  };

  const clearSeriesCache = () => {
    if (window.Tawk_API) {
      console.log("Shutting down Tawk.to...");
      // window.Tawk_API.shutdown();
    }
    localStorage.clear();
  sessionStorage.clear();

  // Manually remove specific cookies by setting them to expire in the past
  const cookiesToDelete = [
    "token",
    "csrf_token",
    "_fbp",
    "__stripe_sid",
    "__stripe_mid",
  ];

  cookiesToDelete.forEach((cookieName) => {
    Cookies.remove(cookieName, { path: "/" }); // Removes from root path
    Cookies.remove(cookieName, { path: "", domain: window.location.hostname }); // Removes from specific domain
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
  });

  // Attempt to clear all cookies by iterating through document.cookie
  document.cookie.split(";").forEach((cookie) => {
    const cookieName = cookie.split("=")[0].trim();
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
  });

  console.log("All local storage, session storage, and specified cookies cleared!");
  // setTimeout(() => {
  //   window.location.reload();
  // }, 500);
  };

  const tokenString = localStorage.getItem("tokenuser");
  const adminString = localStorage.getItem("admin");
 
  const tokens = tokenString ? JSON.parse(tokenString) : null;
  const admins = adminString ? JSON.parse(adminString) : null;

  const userids = tokens?.id || admins?.id;
 
  const renderSearchBar = () => {
    // if (!showSearchBar) {
    //   return null;
    // }

    return (
      <div  className="gpuwiz-search-wrapper">
        <InputGroup className="gpuwiz-search-bar">
          <InputGroup.Text id="basic-addon1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
          </InputGroup.Text>
          <Form.Control
            placeholder="Search For GPU"
            aria-label="Search For GPU"
            type="text"
            value={searchValue}
            aria-describedby="basic-addon1"
            autoComplete="off"
            onChange={(e) => {
              setSearchValue(e.target.value);
              setSearchloader(true);
              setShowPopUp(true);
            }}
            onClick={() => setShowPopUp(true)}
          />
          {closeIcon ? (
            <div className="custom_svgCross">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="#000"
                className="bi bi-x"
                viewBox="0 0 16 16"
                onClick={() => {
                  handleCancelIcon();
                  // setShowPopUp(false);
                  setSearchValue("");
                }}
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          ) : (
            ""
          )}
        </InputGroup>
      
        {showPopUp && searchValue ? (
          <div ref={popupRef} className="search-dropdown search-dropdown-mobile">
            <div className="search-list-custom header-list">
              {searchloader ? (
                <>
                  {[...Array(5)].map((_, i) => (
                    <ListGroup.Item className="search-list" key={i}>
                      <div className="d-flex align-items-center gap-5">
                        {/* Skeleton for Image */}
                        <Box sx={{ width: 100, height: 80 }}>
                          <Skeleton variant="rectangular" width={"100%"} height={"100%"} sx={{ borderRadius: "8px" }} />
                        </Box>

                        {/* Skeleton for Text */}
                        <div className="custom-list w-100">
                          <Skeleton variant="text" width="50%" height={22} />
                          <Skeleton variant="text" width="75%" height={22} />
                          <Skeleton variant="text" width="60%" height={22} />
                          <Skeleton variant="text" width="40%" height={20} />
                        </div>
                      </div>
                    </ListGroup.Item>
                  ))}
                </>
              ) : Data?.length > 0 ? (
                <>
                  <ListGroup as="ul" className={showPopUp ? "" : "hide"}>
                    {Object.keys(brandCounts).map((brand, index) => (
                      <div key={index}>
                        <button
                          type="button"
                          style={{
                            backgroundColor: "white",
                            border: "none",
                            boxShadow: "none",
                            cursor: "pointer",
                          }}
                          title={brand}
                          onMouseDown={() =>
                            handleDataClick({
                              type: "brand",
                              name: brand,
                              checked: true,
                            })
                          }
                        >
                          Total: <b>{brandCounts[brand]}</b> results found in{" "}
                          <b>{brand}</b>
                        </button>
                      </div>
                    ))}
                    {Object.keys(modelCounts).map((model, index) => (
                      <div key={index}>
                        <button
                          type="button"
                          style={{
                            backgroundColor: "white",
                            border: "none",
                            boxShadow: "none",
                            cursor: "pointer",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            width: "100%",
                            textAlign: "left",
                          }}
                          title={model}
                          onMouseDown={() =>
                            handleDataClick({
                              type: "model",
                              name: model,
                              checked: true,
                            })
                          }
                        >
                          Total: <b>{modelCounts[model]}</b> results found in{" "}
                          <b>{model}</b>
                        </button>
                      </div>
                    ))}
                    {Object.keys(seriesCounts).map((series, index) => (
                      <div key={index}>
                        <button
                          type="button"
                          style={{
                            backgroundColor: "white",
                            border: "none",
                            boxShadow: "none",
                            cursor: "pointer",
                          }}
                          title={series}
                          onMouseDown={() =>
                            handleDataClick({
                              type: "series",
                              name: series,
                              checked: true,
                            })
                          }
                        >
                          Total: <b>{seriesCounts[series]}</b> results found
                          in <b>{series}</b>
                        </button>
                      </div>
                    ))}
                      {Object.keys(chipsetCounts).map((chipset, index) => (
                        <div key={index}>
                          <button
                            type="button"
                            style={{
                              backgroundColor: "white",
                              border: "none",
                              boxShadow: "none",
                              cursor: "pointer",
                            }}
                            title={chipset}
                            onMouseDown={() =>
                              handleDataClick({
                                type: "chipset",
                                name: chipset,
                                checked: true,
                              })
                            }
                          >
                            Total: <b>{chipsetCounts[chipset]}</b> results found
                            in <b>{chipset}</b>
                          </button>
                        </div>
                      ))}
                      {Data?.map((val, i) => (
                        <ListGroup.Item
                          as="li"
                          key={i}
                          className=""
                        >
                          <div
                            onMouseDown={() => {
                              navigate(`/product/${val.slug}`);
                              setShowPopUp(false);
                              setSearchValue("");
                              setData([]);
                            }}
                            className="d-flex align-items-center gap-5">
                            <LazyLoadImage src={val.image[0]} alt={val.model} />
                            <div className="custom-list">
                            <p className="mb-0" style={{ fontSize: '14px', lineHeight: '14px' }}>{val.brand}</p>
                            <h3 style={{ fontSize: '14px', lineHeight: '14px' }}>{val.series}</h3>
                            <h3 style={{
                              fontWeight: 'normal',
                              fontSize: '12.6px',
                              lineHeight: '12.6px',
                              whiteSpace: 'normal',
                              overflow: 'hidden',
                              marginTop: '5px'
                            }}>{val.model}</h3>
                            <h5 style={{ color: "#0b4068", fontSize: '12.6px', lineHeight: '12.6px', fontWeight: 'bold', marginTop: '3px' }}>
                              Condition:{" "}
                              {val.type == 1
                                ? "New"
                                : val.type == 2
                                  ? "New(Resale)"
                                  : "Used(Tested)"}
                            </h5>
                          </div>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </>
              ) : (
                <div>
                  <p className="text-center fs-3">
                    <b>No Data Found</b>
                  </p>
                </div>
              )}
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div>
  
      <ToastContainer />
      <Navbar className="px-4" expand="lg">
        <Navbar.Brand href="#home">
          <div className="logo-part">
            <Link to="/"
            onClick={handleBrowselogo}
            >
              <img src="https://gpu-wiz.s3.us-west-1.amazonaws.com/socialicons/1744605202112_mainnnn_logo-min.png"
               style={{ height: '42px', width: '150px' }} 
               alt="Logo" 
              />
            </Link>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {
          showSearchBar && (
<div className="gpuwiz-search-container">{renderSearchBar()}</div>
          )
        }

        
        <Navbar.Collapse id="basic-navbar-nav" className="mt-3 mt-lg-0">
          <div className="header_right_content">
            <Link
              to="/categories/graphic-cards" // Provide the destination here
              onClick={handleBrowseClick} // Custom logic handled here
              className="text-dark mx-2 fs-5 fw-500"
            >
              Browse
            </Link>
            <Link to="/sell" className="text-dark mx-2 fs-5 fw-500">
              Sell
            </Link>

            <Link to="/userBuySell" className="text-dark mx-2 fs-5 fw-500">
              Buy/Sell
            </Link>
            <Link to="/about" className="text-dark mx-2 fs-5 fw-500">
              About
            </Link>
            {/* <Link to="/list" className="text-dark mx-2 fs-5 fw-500">
              News
            </Link> */}
            <Link to="/help" className="text-dark mx-2 fs-5 fw-500">
              Help
            </Link>
            <button 
              className="text-dark mx-2 fs-5 fw-500 custom-header" 
              style={{ position: 'relative', cursor: 'pointer', background: 'transparent', border: 'none', display: 'inline-block' }}
            >
              {" "}
              <div className="d-flex align-items-center gap-2 lg:ms-3 ">
                {token || token1 ? (
                  <>
                    <Button
                      className="bg-transparent border-0 p-0"
                      onClick={() => setDropList(!DropList)}
                      style={{ cursor: 'pointer' }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        className="bi bi-person-circle"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                        <path
                          filerule="evenodd"
                          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                        />
                      </svg>
                    </Button>
                  </>
                ) : (
                  <Button
                    className="bg-transparent border-0 p-0"
                    onClick={() => handleShow()}
                    style={{ cursor: 'pointer' }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      className="bi bi-person-circle"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                      <path
                        filerule="evenodd"
                        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                      />
                    </svg>
                  </Button>
                )}
              </div>
              <OutsideClickHandler
                onOutsideClick={() => {
                  setDropList(false);
                }}
              >
                {DropList ? (
                  <div className="dropdown">
                    <div className="inner_drop">
                   
                      {token || userId ? (
                        <Link to={`/profile/${userids}`}>Profile</Link>
                      ) : (
                        <Link to="#">Profile</Link>
                      )}
                      {token ? (
                        <Link to="/buySellManagment/selling">Dashboard</Link>
                      ) : null}
                      {token1 ? <Link to="/productlist">Dashboard</Link> : null}
                      {token || token1 ? (
                        <p
                          onClick={() => {
                            clearSeriesCache();
                            navigate("/");
                            window.dispatchEvent(new Event("Loginout"));
                            window.dispatchEvent(new Event("authChange"));
                          }}
                          onMouseEnter={() => setIsLogoutHovered(true)}
                          onMouseLeave={() => setIsLogoutHovered(false)}
                          style={{ fontSize: isCompactNav ? '14px' : '', color: isLogoutHovered ? '#000' : '#4d4d4d', cursor: 'pointer' }}
                        >
                          Log Out
                        </p>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </OutsideClickHandler>
            </button>
          </div>
        </Navbar.Collapse>
        {/* search bar closed */}
      </Navbar>

      {
        showSearchBar && (
          <div
            className={`gpuwiz-search-container-mobile px-4`}
          >
            {renderSearchBar()}
          </div>
        )
      }

      {/* Login PopUp Start */}
      <Login
        forgot={forgot}
        setForgot={setForgot}
        signup={signup}
        setSignup={setSignup}
        modal={handleClose}
        show={show}
        setShow={setShow}
      />
      {/* Login Popup End */}
      <div className={showPopUp ? "" : ""}></div>  {/* showPopUp ? "addOverlay" : "" mobile search addOverlay removed */}
    </div>
  );
}
